/* @flow */
import * as React from 'react';
import Link from 'components/Link';
import Text from 'components/Text';
import TextWithGlyph from 'components/TextWithGlyph';
import QuickPromotion from 'entities/QuickPromotion';

import './styles/ClassNavigationPromotion.scss';

export default class ClassNavigationPromotion extends React.Component<{
  promotion: QuickPromotion,
  onConfirm: Function,
}> {
  render() {
    const { promotion } = this.props;
    return (
      <Link block onClick={this.props.onConfirm} className="ClassNavigationPromotion">
        <TextWithGlyph glyph="explanation-circle" glyphColor="whiteout" glyphSize="xlarge">
          <Text
            className="ClassNavigationPromotion-body"
            element="div"
            color="whiteout"
            size="xxxsmall">
            {promotion.getBody()}
          </Text>
        </TextWithGlyph>
      </Link>
    );
  }
}
